module.exports = __webpack_public_path__ + "img/06-326x184-chinnichi-everitt.1d3d1a96.jpg";